import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${article.slug}`}
      className="group flex flex-col sm:flex-row gap-4 bg-background-50 border border-background-200/70 rounded-lg overflow-hidden transition-all duration-300 hover:border-primary-300 cursor-pointer"
    >
      <div className="relative sm:w-48 lg:w-56 shrink-0 aspect-[16/10] sm:aspect-auto overflow-hidden">
        <img
          src={article.coverImage}
          alt={article.title}
          title={`${article.title} - h游戏攻略资讯`}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex flex-col justify-center p-4 sm:p-0 sm:pr-4 sm:py-4 flex-1 min-w-0">
        <div className="flex items-center gap-2 mb-2">
          <span className="px-2 py-0.5 text-[10px] font-medium bg-accent-100 text-accent-700 rounded-md whitespace-nowrap">
            {article.category}
          </span>
          <span className="text-[11px] text-foreground-400 whitespace-nowrap">
            {article.publishDate}
          </span>
          <span className="text-[11px] text-foreground-400 whitespace-nowrap">
            · {article.readTime} 分钟阅读
          </span>
        </div>
        <h3 className="text-sm font-semibold text-foreground-950 mb-1.5 line-clamp-2 group-hover:text-primary-600 transition-colors font-heading">
          {article.title}
        </h3>
        <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed mb-3">
          {article.excerpt}
        </p>
        <div className="flex items-center gap-3 text-[11px] text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-user-line"></i>
            {article.author}
          </span>
          <div className="flex flex-wrap gap-1">
            {article.tags.map((tag) => (
              <span key={tag} className="px-1.5 py-0.5 bg-secondary-100 text-secondary-700 rounded text-[10px] whitespace-nowrap">
                {tag}
              </span>
            ))}
          </div>
        </div>
      </div>
    </Link>
  );
}